import { useApi } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceAccountsApiRef } from '../plugin';
import { UpsertServiceAccountRequest } from '@agilelab/plugin-wb-service-accounts-common';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { QUERY_KEY_SERVICE_ACCOUNTS } from '../constants';

export const useUpsertServiceAccount = (options?: {
  alertOnError: boolean;
}) => {
  const serviceAccountsApi = useApi(serviceAccountsApiRef);
  const queryClient = useQueryClient();
  const alertApi = useApi(customAlertApiRef);

  const defaultOnSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEY_SERVICE_ACCOUNTS],
    });
  };

  return useMutation({
    mutationFn: (request: UpsertServiceAccountRequest) =>
      serviceAccountsApi.upsertServiceAccount(request),
    onSuccess: defaultOnSuccess,
    onError: e => {
      if (options?.alertOnError === false) return;
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
